export default {
  callapp: {
    option: {
      scheme: {
        protocol: "wellcome",
        host: "dmall"
      },
      intent: {
        package: "com.rtahk.wellcome",
        scheme: "wellcome"
      },
      fallback: "",
      timeout: 2000
    },
    appStore: "https://apps.apple.com/cn/app/%E6%83%A0%E5%BA%B7%E7%B6%B2%E5%BA%97/id6473398628",
    googlePlay: "https://play.google.com/store/apps/details?id=com.rtahk.wellcome"
  },
  metaInfo: {},
  googleMapApiKey: "AIzaSyAKPfwxhNLGV_vVyFD0Eye2rY4ZuYaqjV4",
  loginChannel: 6
}
